import { graphql } from "@/lib/gql/__generated__";

export const ContactChatRoomQuery = graphql(/* GraphQL */ `
	query ContactChatRoom($hotelID: ID!, $contactID: ID!) {
		contact(hotelID: $hotelID, contactID: $contactID) {
			id
			hotelID
			contactID
			title
			contactGenre
			messages {
				message
				relatedURLs
				images {
					bucket
					key
					region
					mimeType
					fileName
				}
				senderType
				createdAt
			}
		}
	}
`);
